/**
 * Enumeration of common HTTP status codes.
 */
export enum StatusCode {
  /**
   * 200 OK - The request was successful, and the server has returned the requested data.
   */
  OK = 200,

  /**
   * 201 Created - The request has been fulfilled, resulting in the creation of a new resource.
   */
  CREATED = 201,

  /**
   * 202 Accepted - The request has been accepted for processing, but the processing has not been completed.
   */
  ACCEPTED = 202,

  /**
   * 204 No Content - The request was successful, but there is no response body to return.
   */
  NO_CONTENT = 204,

  /**
   * 301 Moved Permanently - The requested resource has been permanently moved to a new location.
   */
  MOVED_PERMANENTLY = 301,

  /**
   * 302 Found - The requested resource is found, but it has been temporarily moved to a different location.
   */
  FOUND = 302,

  /**
   * 303 See Other - The response to the request can be found under a different URI.
   */
  SEE_OTHER = 303,

  /**
   * 304 Not Modified - The resource has not been modified since the last request.
   */
  NOT_MODIFIED = 304,

  /**
   * 400 Bad Request - The server cannot or will not process the request due to a client error.
   */
  BAD_REQUEST = 400,

  /**
   * 401 Unauthorized - The request lacks proper authentication credentials or is otherwise unauthorized.
   */
  UNAUTHORIZED = 401,

  /**
   * 403 Forbidden - The server understands the request but refuses to fulfill it due to permissions or other reasons.
   */
  FORBIDDEN = 403,

  /**
   * 404 Not Found - The requested resource could not be found on the server.
   */
  NOT_FOUND = 404,

  /**
   * 405 Method Not Allowed - The request method is not supported for the requested resource.
   */
  METHOD_NOT_ALLOWED = 405,

  /**
   * 409 Conflict - The request could not be completed due to a conflict with the current state of the target resource.
   */
  CONFLICT = 409,

  /**
   * 500 Internal Server Error - The server encountered an unexpected condition that prevented it from fulfilling the request.
   */
  INTERNAL = 500,

  /**
   * 501 Not Implemented - The server does not support the functionality required to fulfill the request.
   */
  NOT_IMPLEMENTED = 501,

  /**
   * 502 Bad Gateway - The server, while acting as a gateway or proxy, received an invalid response from an upstream server.
   */
  BAD_GATEWAY = 502,

  /**
   * 503 Service Unavailable - The server is currently unable to handle the request due to temporary overloading or maintenance.
   */
  SERVICE_UNAVAILABLE = 503,

  /**
   * 504 Gateway Timeout - The server, while acting as a gateway or proxy, did not receive a timely response from an upstream server.
   */
  GATEWAY_TIMEOUT = 504,

  /**
   * 505 HTTP Version Not Supported - The server does not support the HTTP protocol version used in the request.
   */
  HTTP_VERSION_NOT_SUPPORTED = 505,
  // Add more status codes and descriptions as needed
}
